
import React from "react";
const HeroSection: React.FC = () => {
  return <div className="pt-24 pb-16 text-center">
      <h1 className="text-5xl md:text-7xl font-playfair mb-6">
        <span className="text-black">Evangelism </span>
        <span className="text-heaven-gold">Training</span>
        <span className="text-black"> Tool</span>
      </h1>
      <p className="text-gray-600 max-w-3xl mx-auto px-4 text-lg leading-relaxed">Equipping Christians to share their faith with confidence, clarity, and compassion. Learn effective ways to communicate the Gospel and engage in meaningful spiritual conversations. Use this tool to engage in simulated conversations with real pushback and real challenges. Use this tool to sharpen your sword!</p>
    </div>;
};
export default HeroSection;

